export default __webpack_public_path__ + "static/media/avatarB1.0a5bb77b.png";